<script setup lang="ts">
import { LOCALE } from "core/interfaces";

import { getKindLinks } from "~/common/helpers/get-kind-links";

const { locale } = useI18n();
const shopStore = useShopStore();

const kindLinks = computed(() => getKindLinks(locale.value as LOCALE, shopStore.components.kinds));

const getCardUrl = (kindId: number) => {
	const kind = shopStore.components.kinds.find(kind => kind.id === kindId);

	if (kind?.translations) {
		const translation = kind.translations.find(translation => translation.locale === LOCALE.ENGLISH);

		return `img/card-kind-${translation?.name.toLowerCase()}.webp`;
	} else {
		return "";
	}
};
</script>

<template>
	<section class="grid gap-4 grid-cols-7 h-[600px] xs:grid-cols-3">
		<HomeCardsItem
			v-for="(kindLink, i) in kindLinks"
			:key="kindLink.id"
			:class="i ? 'col-span-2 xs:col-span-3' : 'col-span-3 xs:col-span-3'"
			:title="kindLink.name"
			:link="kindLink.link"
			:amount="shopStore.productsCount[kindLink.id]"
			:img-url="getCardUrl(kindLink.id)"
		/>
	</section>
</template>
